import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledReportSent';

export const ReportSent = () => {
    const { t, modal, setModal } = useCXI();
    const { match } = modal;

    return (
        <Styled.ReportSent as={Container.Slim}>
            <Container.Head image={match.startup.logoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.ReportSent.title')}</Styled.Title>
                <Styled.Descr>{t('modal.ReportSent.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.ReportSent>
    );
};
